// extracted by mini-css-extract-plugin
export default {"wrapper":"DatePill_wrapper__T2Vs4","pill":"DatePill_pill__o20cZ","icon":"DatePill_icon__TeIdZ","label":"DatePill_label__pQEQx","date":"DatePill_date__y1pN1"};